import React from 'react';
import LWButton from 'components/legacy/LWButton';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SLWButton = styled(LWButton)`
	${({ $opacity }) => `opacity: ${$opacity};`}
	transition: opacity 0.25s;
`;

function DismissButton({ onClick, visible = true }) {
	return (
		<SLWButton
			onClick={visible ? onClick : undefined}
			variant="textPrimaryDark"
			$opacity={Number(visible)}
		>
			Dismiss
		</SLWButton>
	);
}

DismissButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	visible: PropTypes.bool,
};

export default DismissButton;
